import { Control, Map } from 'leaflet';
import { BehaviorSubject, Observable, Subject, Subscription, takeUntil } from 'rxjs';

export class CenterControl extends Control {
    destroy$ = new Subject<void>();
    isLocked?: BehaviorSubject<boolean>;
    isPositionAvailable?: Observable<boolean>;

    private posAvalSubscription?: Subscription

    centerButton?: HTMLElement;
    lockButton?: HTMLElement;

    constructor(options?: any) {
        super(options);
    }

    override onAdd(map: Map) {
        const div = document.createElement('div');
        div.className = 'leaflet-bar leaflet-control leaflet-control-custom';
        div.innerHTML = `
      <button title="Center on my location" class="center-button">
        <span class="material-symbols-outlined">my_location</span>
      </button>
      <button title="Lock position" class="lock-button">
        <span class="material-symbols-outlined">${this.isLocked?.getValue() ? 'lock' : 'lock_open'}</span>
      </button>
    `;

        this.centerButton = div.querySelector('.center-button') as HTMLElement;
        this.lockButton = div.querySelector('.lock-button') as HTMLElement;

        this.centerButton.onclick = (e: MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();
            (map as any).centerOnUser();
        };

        this.lockButton.onclick = (e: MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();
            (map as any).toggleLockUser();
        };



        if (this.isLocked?.getValue()) {
            this.lockButton.setAttribute('active', '');
        } else {
            this.lockButton.removeAttribute('active');
        }

        return div;
    }

    override onRemove(map: Map) {
        this.destroy$.next();
        this.destroy$.complete();
    }

    setLockSubject(s: BehaviorSubject<boolean>) {
        if (this.isLocked) {
            this.isLocked.unsubscribe()
        }
        this.isLocked = s
        this.isLocked.pipe(takeUntil(this.destroy$)).subscribe(locked => {
            if (!this.lockButton) return;
            this.lockButton.innerHTML = `<span class="material-symbols-outlined">${locked ? 'lock' : 'lock_open'}</span>`;
            if (locked) {
                this.lockButton.setAttribute('active', '');
            } else {
                this.lockButton.removeAttribute('active');
            }
        })
    }

    setPositionAvailableSubject(s: Observable<boolean>) {
        if (this.posAvalSubscription) {
            this.posAvalSubscription.unsubscribe()
        }
        this.isPositionAvailable = s
        this.posAvalSubscription = this.isPositionAvailable.pipe(takeUntil(this.destroy$)).subscribe(available => {
            if (!this.centerButton || !this.lockButton) return;
            if (available) {
                this.centerButton.removeAttribute('unavailable');
                this.lockButton.removeAttribute('hidden');
            } else {
                this.centerButton.setAttribute('unavailable', '');
                this.lockButton.setAttribute('hidden', '');
            }
        })
    }
}